import type { StringOverrides } from "./index";
import { enUS } from "./en-US";

/**
 * en-CA override table. Canadian English shares most NA trade
 * vocabulary with US (estimate, real estate agent, contractor) so
 * we re-use the en-US overrides as the baseline. CA-specific
 * deviations get added directly in this file as we identify them.
 *
 * Genuine CA-only candidates (none in en.ts today, but for future
 * keys): Service Tax labelling (GST/HST/PST/QST is province-keyed
 * via the jurisdiction lookup, not the strings registry). Provincial
 * cert names if they leak into copy.
 */
export const enCA: StringOverrides = {
  ...enUS,
};
